import { AcOnlinetestModel } from './ac-onlinetest.model';
import { ResourceModel } from './resource.model';

export class CandidateOnlinetestModel extends AcOnlinetestModel {

  // columns
  uid: string;
  identifier: string;
  login_url: string; // tslint:disable-line: variable-name
  login_user: string; // tslint:disable-line: variable-name
  login_password: string; // tslint:disable-line: variable-name
  started_at: any; // tslint:disable-line: variable-name
  complete: boolean;

  // relations
  resources: Array<ResourceModel>;

  deserialize(input: any): this {
    Object.assign(this, super.deserialize(input));
    // reports
    let resources = null;
    if (this.resources !== null && this.resources !== undefined) {
      resources = [];
      this.resources.forEach((resource: ResourceModel) => {
        resources.push(new ResourceModel().deserialize(resource));
      });
    }
    this.resources = resources;
    return this;
  }

}
